import { CustomHandler } from "@crescentParts/Store/CustomHandlerCreator";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomHandler<{ahriSystemToolPageNumber:number}>

export const DispatchAHRISystemToolPageNumber: HandlerType = props =>{
    props.dispatch({
        type:"Custom/AHRISystemToolConfigPagination/PageNumber",
        pageNumber:props.parameter.ahriSystemToolPageNumber
    })
}

export const chain = [DispatchAHRISystemToolPageNumber];

const AHRISystemPaginationHandler = createHandlerChainRunner(chain,"PageNumber");
export default AHRISystemPaginationHandler;